import React from 'react';
import { SxProps, Box } from '@mui/material';

type Props = {
  headerBar: JSX.Element;
  navBar: JSX.Element;
  children: React.ReactNode;
};

export const Page = ({ headerBar, navBar, children }: Props): JSX.Element => {

  const headerHeight = '100px';
  const navBarWidth = 'minmax(200px, 20%)';

  const pageStyle: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    height: '100dvh',
    overflow: 'hidden',
    backgroundColor: '#222',
  };

  const headerStyle: SxProps = {
    zIndex: 1,
    height: headerHeight,
  };

  const layoutStyle: SxProps = {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    minHeight: 0,
  };

  const navStyle: SxProps = {
    zIndex: 1,
    width: navBarWidth,
  };

  const mainStyle: SxProps = {
    flex: 1,
    overflow: 'auto',
    scrollbarGutter: 'stable',
  };

  return (
    <Box sx={pageStyle}>
      <Box sx={headerStyle}>{headerBar}</Box>
      <Box sx={layoutStyle}>
        <Box sx={navStyle}>{navBar}</Box>
        <Box sx={mainStyle}>{children}</Box>
      </Box>
    </Box>
  );
};

export default Page;
